/**
 * InputPassword Component - Template
 * ==================================
 */

export const INPUT_PASSWORD_TEMPLATE: string = `
<div class="ec-input-password ec-flex ec-flex-col ec-gap-1">
  <label
    ng-if="$ctrl.label || $ctrl.hasLabelSlot"
    ng-attr-for="{{ $ctrl.resolvedId }}"
    ng-class="$ctrl.getLabelClasses()"
  ><span ng-if="$ctrl.hasLabelSlot" ng-transclude="labelSlot"></span><span ng-if="!$ctrl.hasLabelSlot">{{ $ctrl.label }}</span></label>

  <div class="ec-flex ec-flex-col ec-gap-1">
    <div ng-class="$ctrl.getControlClasses()">
      <input
        ng-attr-id="{{ $ctrl.resolvedId }}"
        ng-attr-type="{{ $ctrl.inputType }}"
        ng-attr-autocomplete="{{ $ctrl.autocomplete }}"
        ng-class="$ctrl.getInputClasses()"
        ng-model="$ctrl.inputValue"
        ng-change="$ctrl.handleInput()"
        ng-disabled="$ctrl.disabled"
        placeholder="{{ $ctrl.placeholder }}"
        ng-attr-aria-invalid="{{ $ctrl.error ? 'true' : undefined }}"
        ng-attr-aria-describedby="{{ ($ctrl.helpMessage || $ctrl.hasHelpSlot) ? $ctrl.helpId : undefined }}"
      />
      <button
        type="button"
        ng-class="$ctrl.getToggleClasses()"
        ng-click="$ctrl.toggleVisibility()"
        ng-disabled="$ctrl.disabled"
        ng-attr-aria-label="{{ $ctrl.toggleAriaLabel }}"
        ng-attr-aria-pressed="{{ $ctrl.visible ? 'true' : 'false' }}"
      >
        <span ng-if="!$ctrl.visible" ng-class="$ctrl.getIconClasses()" ng-bind-html="$ctrl.trustedEyeOff" aria-hidden="true"></span>
        <span ng-if="$ctrl.visible" ng-class="$ctrl.getIconClasses()" ng-bind-html="$ctrl.trustedEye" aria-hidden="true"></span>
      </button>
    </div>

    <span
      ng-if="$ctrl.helpMessage || $ctrl.hasHelpSlot"
      ng-attr-id="{{ $ctrl.helpId }}"
      ng-class="$ctrl.getHelpClasses()"
    ><span ng-if="$ctrl.hasHelpSlot" ng-transclude="helpSlot"></span><span ng-if="!$ctrl.hasHelpSlot">{{ $ctrl.helpMessage }}</span></span>
  </div>
</div>
`;

export default INPUT_PASSWORD_TEMPLATE;
